import styled from "styled-components";
import { includeStyledSystem, sx } from "../../util/styledSystem";
export const ModalFooter = styled.div.attrs({ "data-testid": "ModalFooter" }) `
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  min-width: 0;
  ${({ theme: { space, radii, colors: { modalColors }, }, }) => ({
    backgroundColor: modalColors.modalFooter,
    borderBottomLeftRadius: radii[1],
    borderBottomRightRadius: radii[1],
    marginTop: space[3],
    paddingBottom: space[3],
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: space[3],
})}

  ${includeStyledSystem()}
  ${sx}
`;
